import { connectFela } from '../../dependencies';
import SelectMembershipRole from './SelectMembershipRole';
import * as styles from './SelectMembershipRole.styles';

export default connectFela(styles)(SelectMembershipRole);
